import { SearchCriteria } from "./search-criteria";

export class ClientsGroupsMasterSearchCriteria extends SearchCriteria {

  public Id: number;
  
}
